import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { useDictionary } from '@/src/app/hooks';
import type { UnitDTO } from '@/src/ui';

interface LessonNavProps {
    unit: UnitDTO;
    grade: string;
    selectedLessonIndex: number | null;
    setSelectedLessonIndex: (lesson: number | null) => void;
}

const LessonNav: React.FC<LessonNavProps> = ({
    unit,
    grade,
    selectedLessonIndex,
    setSelectedLessonIndex,
}) => {
    const { translate } = useDictionary();
    const navigate = useNavigate();
    const params = useParams();
    const hasUnitParam = !!params.unit;

    const validLessonIndices = (unit.lessons || []).reduce<number[]>((indices, lesson, index) => {
        if (lesson.lessonNumber !== 99) {
            indices.push(index);
        }
        return indices;
    }, []);
    const selectedPosition =
        selectedLessonIndex === null ? -1 : validLessonIndices.indexOf(selectedLessonIndex);

    function updateSelectedLesson(diff: number) {
        if (selectedLessonIndex === null) {
            return;
        }
        const currentPosition = validLessonIndices.indexOf(selectedLessonIndex);
        if (currentPosition === -1) {
            return;
        }
        const newPosition = Math.max(
            0,
            Math.min(validLessonIndices.length - 1, currentPosition + diff)
        );
        setSelectedLessonIndex(validLessonIndices[newPosition]);
    }
    return (
        <div id="lesson-nav-wrapper">
            <div id="lesson-nav" className="lessonNav">
                <a
                    href="#"
                    id="backToUnitsLink"
                    className="grade-back-link pd-dark text"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (hasUnitParam) {
                            navigate(`/lessons/${grade}`, { replace: true });
                        }
                        setSelectedLessonIndex(null);
                    }}
                >
                    {`< ${translate('Grade')} ${grade} (${translate('Back')})`}
                </a>
                <div className="lesson-link-navigation">
                    <a
                        href="#"
                        id="previousLessonLink"
                        className={`pd-dark text ${selectedPosition <= 0 ? ' disabled' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            updateSelectedLesson(-1);
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        {`< ${translate('Previous Lesson')}`}
                    </a>
                    &nbsp;|&nbsp;
                    <a
                        href="#"
                        id="nextLessonLink"
                        className={`pd-dark text ${selectedPosition === validLessonIndices.length - 1 ? ' disabled' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            updateSelectedLesson(1);
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        {`${translate('Next Lesson')} >`}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default LessonNav;
